export default __webpack_public_path__ + "static/media/icon-crosshair.ef731244.svg";